__webpack_require__.p = "/microsoft-meeting-rooms-discovery-2d2ntxa/referrals-hub/";